import React from 'react';
import { useParams } from 'react-router-dom';
import { useProductStatus, ProductType } from 'hooks/use-product-status.hook';
import { ErrorPage } from 'components/errors';
import { LoadingPage } from 'components/loading';
import { Unavailable } from './unavailable';
import { Default } from './default';

export const Closed = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, error, loading } = useProductStatus(
    ProductType.Vnm,
    Number(planId)
  );

  if (loading) return <LoadingPage dataTestId="solar-closed-loading" />; // TODO: update loading layout once sunrise is complete
  if (error || !data) return <ErrorPage />;

  return data.isUnavailable ? <Unavailable /> : <Default />;
};
